import React, { ReactElement } from "react";
import { Divider, CheckCircleIcon } from "staysure-component-library";

import TextSelectionButton from "@/components/atoms/text-selection-button/text-selection-button";
import CancellationCoverModal from "@/components/molecules/quote-section/quote-cover/modal/cancellation-cover-modal";
import { ANNUAL_MULTI_TRIP } from "@/constants";
import { BenefitCopyDataType } from "@/schema/quote-page/page.schema";
import { DynamicCoverLimitProduct } from "@/types/DynamicCoverLimitProductType";

export type CancellationCoverModalProps = {
  changeCta?: string;
  cancellationCoverTitle: string;
  cancellationCoverDescription: string;
  cancellationDropdownLabel: string;
  cancellationCoverUpdateCta: string;
  cancellationCoverCancelCta: string;
};

type ItemProps = {
  id: string;
  icon?: ReactElement;
  className?: string;
  dividerClassName?: string;
  currentPolicy: string;
  benefitsCopy: BenefitCopyDataType;
  isHideDivider?: boolean;
  modalData: CancellationCoverModalProps;
  dynamicCoverLimit: DynamicCoverLimitProduct | null;
};

export function Item({
  id,
  icon,
  benefitsCopy,
  className = "",
  dividerClassName = "",
  currentPolicy,
  modalData,
  isHideDivider = false,
  dynamicCoverLimit,
}: Readonly<ItemProps>) {
  const [isOpened, setIsOpened] = React.useState(false);

  const renderCancellationText = (data: BenefitCopyDataType) => {
    const { description, isCancellation } = data;
    if (isCancellation) {
      const selectedCancellationCover =
        dynamicCoverLimit?.values.find((item) => item.selected) ||
        dynamicCoverLimit?.values.find((item) => item.isDefault);
      return dynamicCoverLimit?.values[0]
        ? `${selectedCancellationCover?.displayValue ?? "N/A"} ${description}`
        : description;
    }
    return description;
  };

  return (
    <div className={`${isHideDivider ? "pb-spacing-l lg:pb-spacing-xs" : ""}`}>
      {isOpened && (
        <CancellationCoverModal
          isOpen={isOpened}
          setIsOpen={setIsOpened}
          values={dynamicCoverLimit?.values || null}
          tripType={ANNUAL_MULTI_TRIP}
          packageType={currentPolicy}
          cancelationCoverTitle={modalData?.cancellationCoverTitle}
          cancelationCoverDescription={modalData?.cancellationCoverDescription}
          cancelationCoverUpdateCta={modalData?.cancellationCoverUpdateCta}
          cancelationCoverCancelCta={modalData?.cancellationCoverCancelCta}
          placeholderText={modalData?.cancellationDropdownLabel}
        />
      )}
      <div className={`flex  items-start gap-spacing-xxs ${className}`}>
        <div>{icon ?? <CheckCircleIcon fill="#008205" />}</div>
        <div>
          <p className="font-body-font text-text-functional-1 text-2xs font-[400] leading-[150%] lg:max-w-[304px]">
            {renderCancellationText(benefitsCopy)}
          </p>
        </div>
        {benefitsCopy?.isCancellation &&
          dynamicCoverLimit?.values &&
          dynamicCoverLimit?.values.length > 1 && (
            <div className="ml-auto">
              <TextSelectionButton
                id={`cover-level-selection-card-bottom-${id}`}
                label={modalData.changeCta ?? "Change"}
                className={` text-[16px] font-body-font font-[600] align-top leading-[150%]
                   hover:text-interactive-secondary-default hover:bg-surface-neutral-option-1 ml-[4px] !px-0`}
                onClick={() => setIsOpened(true)}
              />
            </div>
          )}
      </div>
      {!isHideDivider && (
        <Divider
          margin={12}
          color="#DCDCDC"
          className={`${dividerClassName}`}
        />
      )}
    </div>
  );
}
